/**
 * Função utilitária para combinar classes CSS condicionalmente
 * @param classes Array de classes CSS que serão combinadas
 * @returns String de classes CSS combinadas
 */
export function classNames(...classes: (string | boolean | undefined)[]): string {
  return classes.filter(Boolean).join(' ');
}
